import React, { createContext, useContext } from 'react';

import { Shop } from 'types';

type ManageShopContextValue = {
  shopId: string;
  shopData?: Shop;
  isNew: boolean;
  navigateBack: () => void;
};

const ManageShopContext = createContext<ManageShopContextValue | null>(null);

export const ManageShopProvider: React.FC<
  ManageShopContextValue & { children: React.ReactNode }
> = ({ children, ...value }) => (
  <ManageShopContext.Provider value={value}>
    {children}
  </ManageShopContext.Provider>
);

export const useManageShop = () => {
  const context = useContext(ManageShopContext);
  if (!context) {
    throw new Error('useManageShop must be used within ManageShopProvider');
  }
  return context;
};
